import { motion } from "framer-motion";
import ChatHeader from "./ChatHeader";
import ChatBody from "./ChatBody";
import ChatInput from "./ChatInput";

export default function ChatWindow({
  messages,
  typing,
  sendMessage,
  handleOptionClick,
  bottomRef,
  onClose,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40, scale: 0.92 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 40, scale: 0.92 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
     className="fixed inset-0 z-[9998] w-full h-[100dvh] rounded-none border border-white/10 bg-[#0F172A]/95 backdrop-blur-2xl shadow-[0_20px_60px_rgba(0,0,0,0.45)] overflow-hidden flex flex-col sm:inset-auto sm:bottom-6 sm:right-6 sm:w-[380px] sm:h-[600px] sm:max-h-[calc(100vh-80px)] sm:max-w-[calc(100vw-20px)] sm:rounded-[26px]"
    >
      {/* Animated Background */}
      <div className="absolute inset-0 overflow-hidden">
        <motion.div
          animate={{ x: [-120, 120, -120], y: [-80, 80, -80] }}
          transition={{ repeat: Infinity, duration: 16, ease: "linear" }}
          className="absolute -top-20 -left-20 h-64 w-64 rounded-full bg-fuchsia-500/10 blur-3xl"
        />

        <motion.div
          animate={{ x: [100, -100, 100], y: [80, -80, 80] }}
          transition={{ repeat: Infinity, duration: 18, ease: "linear" }}
          className="absolute bottom-0 right-0 h-72 w-72 rounded-full bg-violet-500/10 blur-3xl"
        />
      </div>

      <div className="relative flex h-full flex-col">
        <ChatHeader onClose={onClose} />

        <ChatBody
          messages={messages}
          typing={typing}
          handleOptionClick={handleOptionClick}
          bottomRef={bottomRef}
        />

        <ChatInput sendMessage={sendMessage} />
      </div>
    </motion.div>
  );
}